import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { getWarehouseKeyValueList } from "../../../services/index";
import toast, { Toaster } from "react-hot-toast";
import PaymentIcon from "@mui/icons-material/Payment";

import { getFormattedNumber } from "../../utils/textUtils";
import { BILL_URL } from "../../../CONSTANTS";
import PaginationDataTable from "../../Common/PaginationDataTable";
import Select from "react-select"

const BillList = (props) => {
    //setting up variables
    let navigate = useNavigate();
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [wareOptions, setWareOptions] = useState(null)
    const [warehouseId, setWarehouseId] = useState({
        label: "",
        value: ""
    });

    useEffect(() => {
        if (!wareOptions) {
            getWarehouseKeyValueList().then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setWareOptions(options);
                    setWarehouseId(options[0]);
                } else {
                    toast(res.message);
                }
            })
        };
    }, []);

    const handleRowClick = (row) => {
        let AdditionalInfo = { warehouse: warehouseId };
        if (props.onRowClicked) {
            props.onRowClicked(row);
        }
        const recordId = row.recordId;
        if (recordId) {
            navigate(`/bills/${recordId}`, { state: AdditionalInfo });
        }
    };

    const handleClickNew = () => {
        navigate('/DirectBill', { state: { directBill: true } });
    };

    const handleRefresh = useCallback(() => {
        setRefreshFlag(prevRefreshFlag => prevRefreshFlag + 1);
    }, []);

    const columns = [
        {
            name: "GRN NO.",
            selector: (data) => data.billNo,
            style: { color: "#007bff" }
        },

        {
            name: "PURCHASE NO.",
            selector: (data) => data.purchaseOrderNo,
            style: { color: "#007bff" }
        },
        {
            name: "BILL DATE",
            selector: (data) => data.billDate,
            style: { color: "#007bff" }
        },
        {
            name: "VENDOR NAME",
            selector: (data) => data.vendorTitle,
            width: "300px",
        },

        {
            name: "PAYMENT STATUS",
            selector: (data) =>
                data.isPaid ? (
                    <Tooltip title="Paid" arrow placement="top">
                        <PaymentIcon style={{ color: "greenyellow" }} />
                    </Tooltip>
                ) : (
                    <>
                        <PaymentIcon style={{ cursor: "pointer" }} onClick={() => navigate("/purchasePayment/" + data.recordId, { state: { id: data.recordId } })} />
                    </>
                ),
        },

        {
            name: "AMOUNT",
            selector: (data) => getFormattedNumber(data.amount),
        },
        {
            name: "BALANCE DUE",
            selector: (data) => getFormattedNumber(data.balanceDue),
        },
        {
            name: "QC STATUS",
            selector: (data) => {
                const getStatus = () => {
                    if (data.qcPassedItemCount === data.totalItemCount) return { color: "#7CFC00", label: "Complete" }; 
                    if (data.qcPassedItemCount === 0) return { color: "#FF1818", label: "Incomplete" }; 
                    if (data.qcPassedItemCount < data.totalItemCount) return { color: "yellow", label: "Partially Completed" };
                    return { color: "", label: "" };
                };

                const { color, label } = getStatus();

                return (
                    <div
                        style={{
                            background: color,
                            height: 12,
                            width: 12,
                            borderRadius: "50%",
                            display: "inline-block",
                            boxShadow: `0 0 6px ${color}`,
                        }}
                        title={label}
                    />
                );
            },
        }




    ]

    const handleWarehouseSelect = (e) => {
        setWarehouseId(e);
        handleRefresh();
    }

    return (
        <>
            <div className="page-container">
                <div className="purchase-warehouse mt-2"><Select options={wareOptions} value={warehouseId} onChange={(e) => handleWarehouseSelect(e)} /></div>
                <div style={{ height: 500, width: "100%" }}>
                    {warehouseId.value !== "" && <PaginationDataTable
                        paginationUrl={BILL_URL() + "getAllRecords"}
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        columns={columns}
                        onRowClicked={handleRowClick}
                        onNewClicked={handleClickNew}
                        filter={{ uuid2: warehouseId?.value }}
                    />}
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default BillList;
